import React, { useState, useEffect } from 'react';
import './Banner.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBanners } from '../../../../slice/banner/bannerSlice';

const Banner = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const dispatch = useDispatch();
  const { banners = [], loading } = useSelector((state) => state.banner || {});

  useEffect(() => {
    dispatch(fetchBanners({ page: 1, limit: 10 }));
  }, [dispatch]);

  // Filter only active banners
  const slides = banners.filter((b) => b.status);

  // Auto slide
  // useEffect(() => {
  //   if (slides.length === 0) return;
  //   const interval = setInterval(() => {
  //     setCurrentSlideIndex((prev) =>
  //       prev >= slides.length - 1 ? 0 : prev + 1
  //     );
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, [slides.length]);

  // Reset index if banners change and index is out of range
  useEffect(() => {
    if (currentSlideIndex >= slides.length) {
      setCurrentSlideIndex(0);
    }
  }, [slides.length]);

  const changeSlide = (direction) => {
    setCurrentSlideIndex((prev) => {
      if (direction > 0) {
        return prev >= slides.length - 1 ? 0 : prev + 1;
      } else {
        return prev <= 0 ? slides.length - 1 : prev - 1;
      }
    });
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  // ── Loading state ──
  if (loading) {
    return (
      <section className="hero-slider" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Loading...</p>
      </section>
    );
  }

  // ── No active banners ──
  if (slides.length === 0) return null;

  return (
    <section className="hero-slider">
      {/* Floating Background Elements */}
      <div className="floating-elements">
        <div className="float-element float-1">✦</div>
        <div className="float-element float-2">✧</div>
        <div className="float-element float-3">❋</div>
      </div>

      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide._id}
          className={`slide ${index === currentSlideIndex ? 'active' : ''}`}
        >
          <div className="slide-content">
            <div className="text-content">
              <div className="abnnerTxt">
                {slide.name}<br />
              </div>
              <p>{slide.description}</p>
              <div className="cta-buttons">
                {slide.buttonText && (
                  <button
                    className="btn-primary CUSradius"
                    onClick={() => {
                      const section = document.getElementById('category-section');
                      if (section) {
                        section.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    {slide.buttonText}
                  </button>
                )}
              </div>
              
            </div>
      {/* Slider Dots */}
      {slides.length > 1 && (
        <div className="slider-controls mobileDot">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlideIndex ? 'active' : ''} `}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}
            <div className="image-content">
              <div className="frame-container">
                <div className="decorative-frame">

                  <div className="frame-inner">
                    {slide.image ? (
                      <div className='BannerDIV'>

                        <img
                          src={`${process.env.REACT_APP_API_URL}/uploads/${slide.image}`}
                          alt={slide.name}
                          className="frame-image"
                        />
                      </div>
                    ) : (
                      <div className="frame-image" style={{ background: '#f1f1f1' }} />
                    )}
                    <div className="frame-overlay"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      {slides.length > 1 && (
        <>
          <div className="arrow arrow-left" onClick={() => changeSlide(-1)}>‹</div>
          <div className="arrow arrow-right" onClick={() => changeSlide(1)}>›</div>
        </>
      )}

  {slides.length > 1 && (
        <div className="slider-controls">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlideIndex ? 'active' : ''} destopDot`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default Banner;